import React  from "react";
import PropTypes  from "prop-types";
import { Link } from "react-router-dom";
import { merge as _merge } from "lodash";

export default class SearchTypes extends React.Component {

    static propTypes = {
        types: PropTypes.array,
        query : PropTypes.object,
        selected: PropTypes.string
    };

    renderType = (type) => {
        return <Link key={type.value} className={"mywort-btn mywort-btn--radius " + ((this.props.selected === type.value) ? 'mywort-btn--switch-on' : 'mywort-btn--switch-off')} to={{ pathname: "/", query: _merge({"type": type.value}, this.props.query[type.value]) }}>{type.label}</Link>
    };

    render = () => {
        return <div className="mywort-btn-group mywort-btn-group--switch" data-role="group" data-aria-label="Button Group">
            { this.props.types.map( (type) => this.renderType(type) ) }
        </div>
    };
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/mobile/SearchTypes.jsx